export default __webpack_public_path__ + "615864e5af93905e6f7871ab72e12076.webp";